import { ActionIcon } from '@mantine/core'
import { IconArrowLeft, IconChevronLeft, IconChevronRight } from '@tabler/icons-react'
import React from 'react'
import { useLeadsSheetStore } from '../../../../../../stores/LeadsStore';
import { useNavigate } from 'react-router-dom';

const LeadSheetArrows = () => {
    const opened = useLeadsSheetStore((s) => s.opened);
    const prevProspect = useLeadsSheetStore((s) => s.prevProspect);
    const nextProspect = useLeadsSheetStore((s) => s.nextProspect);
    const handleClose = useLeadsSheetStore((s) => s.handleClose);
    const index = useLeadsSheetStore((s) => s.index);
    const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
    const loading = useLeadsSheetStore((s) => s.loading);
    const current = useLeadsSheetStore((s) => s.current);

    const navigate = useNavigate();

    const handleNext = () => {
        nextProspect();

        const searchParams = new URLSearchParams(location.search);
        searchParams.set("index", index + 1);
        let nextId = currentContainer.items[index + 1]?.id;
        searchParams.set("contact", nextId);

        navigate({
            pathname: location.pathname,
            search: searchParams.toString(),
        });
    };

    const handlePrev = () => {
        prevProspect();

        const searchParams = new URLSearchParams(location.search);
        searchParams.set("index", index - 1);
        let nextId = currentContainer.items[index - 1]?.id;
        searchParams.set("contact", nextId);

        navigate({
            pathname: location.pathname,
            search: searchParams.toString(),
        });
    };

    if (!opened) {
        return null;
    }
    return (
        <>
            <ActionIcon
                disabled={loading || index <= 0} pos={"fixed"} left={-9} top={"50%"} style={{ transform: "translateY(-50%)", zIndex: 999 }} variant='white' size={"xl"} h={96} w={32} miw={16} onClick={handlePrev}>
                <IconChevronLeft />
            </ActionIcon>
            <ActionIcon
                disabled={loading || index >= currentContainer?.items?.length - 1} pos={"fixed"} right={-9} top={"50%"} style={{ transform: "translateY(-50%)", zIndex: 999 }} variant='white' size={"xl"} h={96} w={32} miw={16} onClick={handleNext}>
                <IconChevronRight />
            </ActionIcon>
        </>
    )
}

export default LeadSheetArrows